import { useEffect, useState } from 'react';

function verifyRedirect() {
  if (typeof window === 'undefined') {
    return null;
  }

  const currentSearch = window.location.search;

  return currentSearch;
}

const Warehouse = () => {
  const [pathURL, setPathURL] = useState(null);

  useEffect(() => {
    const searchInfo = verifyRedirect();
    if (searchInfo) {
      setPathURL(`https://opendock.com/` + searchInfo);
      window.location.href = pathURL;
    } else {
      window.location.href = `https://opendock.com/`;
    }
  }, [pathURL]);
  return <div />;
};

export default Warehouse;
